import { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.bearing-intelligence.com';

const CATEGORIES = ['general', 'content', 'design', 'feature request', 'bug'];

export default function FeedbackButton({ token }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');
  const [category, setCategory] = useState('general');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!token) return null;

  const submit = async () => {
    if (!text.trim()) return;
    setLoading(true);
    try {
      await fetch(`${API_URL}/api/beta/feedback`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'Authorization':`Bearer ${token}` },
        body: JSON.stringify({
          feedback_text: text,
          category,
          page_context: window.location.pathname
        })
      });
      setSubmitted(true);
      setTimeout(() => { setOpen(false); setSubmitted(false); setText(''); }, 2000);
    } catch(e) {}
    setLoading(false);
  };

  return (
    <>
      {/* Floating button */}
      <button
        onClick={() => setOpen(o => !o)}
        title="Submit feedback"
        style={{
          position:'fixed', bottom:24, right:24, zIndex:500,
          width:44, height:44, borderRadius:'50%',
          backgroundColor:'#141b27',
          border:'1px solid rgba(196,165,99,0.3)',
          color:'#c4a563', fontSize:18,
          cursor:'pointer', boxShadow:'0 2px 12px rgba(0,0,0,0.5)',
          display:'flex', alignItems:'center', justifyContent:'center',
          transition:'all 0.15s'
        }}
      >
        {open ? '×' : '💬'}
      </button>

      {/* Feedback panel */}
      {open && (
        <div style={{
          position:'fixed', bottom:78, right:24, zIndex:500,
          width:300, backgroundColor:'#141b27',
          border:'1px solid #1e2a3a', borderRadius:8,
          padding:16, boxShadow:'0 4px 24px rgba(0,0,0,0.6)',
          fontFamily:"'Inter', sans-serif"
        }}>
          {submitted ? (
            <div style={{ textAlign:'center', padding:'12px 0' }}>
              <div style={{ fontSize:24, marginBottom:8 }}>✓</div>
              <div style={{ color:'#52b788', fontSize:13, fontWeight:600 }}>Thank you — feedback received</div>
              <div style={{ color:'#4a5568', fontSize:11, marginTop:4 }}>Your input shapes the platform.</div>
            </div>
          ) : (
            <>
              <div style={{ fontSize:11, fontWeight:600, letterSpacing:'0.8px', textTransform:'uppercase', color:'#4a5568', marginBottom:10 }}>
                BETA FEEDBACK
              </div>
              <select
                value={category}
                onChange={e => setCategory(e.target.value)}
                style={{ width:'100%', backgroundColor:'#0f1520', border:'1px solid #1e2a3a', borderRadius:4, padding:'6px 10px', fontSize:12, color:'#8896a8', marginBottom:10, fontFamily:'inherit' }}
              >
                {CATEGORIES.map(c => <option key={c} value={c}>{c.charAt(0).toUpperCase()+c.slice(1)}</option>)}
              </select>
              <textarea
                value={text}
                onChange={e => setText(e.target.value)}
                placeholder="What's working? What isn't? What do you wish existed?"
                rows={4}
                style={{ width:'100%', backgroundColor:'#0f1520', border:'1px solid #1e2a3a', borderRadius:4, padding:'8px 10px', fontSize:13, color:'#e2e8f0', fontFamily:'inherit', resize:'vertical', marginBottom:10, lineHeight:1.5 }}
              />
              <button
                onClick={submit}
                disabled={loading || !text.trim()}
                style={{ width:'100%', backgroundColor:'#c4a563', color:'#090d14', border:'none', borderRadius:4, padding:'8px 0', fontSize:12, fontWeight:600, cursor: text.trim() ? 'pointer' : 'not-allowed', opacity: text.trim() ? 1 : 0.5 }}
              >
                {loading ? 'Sending…' : 'Submit Feedback'}
              </button>
            </>
          )}
        </div>
      )}
    </>
  );
}
